module.exports = __webpack_public_path__ + "static/img/manual-8.4d5d844.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-8.png
// module id = aPjW
// module chunks = 4